import React from 'react';

import RegisterStepper from '@/components/organism/Registration/RegisterStepper';

const Register: React.FC = () => <RegisterStepper />;

export default Register;
